import { api } from '@everfi/reactifi/src/reducers/ApiReducer';
import { routerReducer as routing } from 'react-router-redux';

export default { api, routing };
